import styled from "styled-components"
import { motion } from "framer-motion"
import { theme } from "UI/theme"

export const SelectorWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 11rem;
  margin-left: 5vw;
  position: absolute;
  bottom: 10vh;
  transform: translateX(-1rem);
  pointer-events: all;
  transition: 1s;
  opacity: 1;
  transition-delay: 1s;
  ${({ hide }) =>
    hide &&
    `
    opacity: 0;
    transition: 0.5s;
    transition-delay: 0s;

  `}
`

export const CircleBorder = styled.div`
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${theme.palette.neutral.light};
  border-radius: 50%;
  cursor: pointer;
`

export const FlagCircle = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  & #flag {
    transition: 0.3s;
    width: 95%;
    height: 95%;
  }
`

export const FlagContainer = styled.div`
  position: relative;
  height: 2.5rem;
  width: 3rem;
`
export const Flag = styled(motion.div)`
  background: url(${({ src }) => src}) content-box;
  border-radius: 50%;
  height: 2.5rem;
  width: 2.5rem;
  cursor: pointer;
  padding: 2px;
  position: absolute;
  left: 50%;
  top: 0%;
  transform: translate3d(-50%, 0, 0);
`

export const Arrow = styled.img`
  height: 0.7rem;
  transition: 0.3s;
  filter: invert();
  transform: rotate(${props => (props.turned ? "180deg" : "0deg")});
  margin-left: auto;
  padding: 0 0.5rem;
`

export const Dropdown = styled.ul`
  border: 1px solid
    ${props => (props.border ? theme.palette.neutral.light : "transparent")};
  color: ${theme.palette.neutral.light};
  transition: 0.3s;
  list-style: none;
  margin-top: 0.2rem;
  user-select: none;
  max-height: 10rem;
  overflow: hidden;
  a,
  a:active,
  a:visited {
    text-decoration: none;
    color: rgba(255, 255, 255, 1);
  }
  background: ${props => (props.border ? "rgba(0,0,0,0.7)" : "transparent")};
  z-index: 1000;
  font-size: ${theme.textStyles.languageSelector.fontSize};
  font-weight: ${theme.textStyles.languageSelector.fontWeight};
  font-family: ${theme.textStyles.languageSelector.fontFamily};
`

export const DropdownElement = styled(motion.li)`
  display: flex;
  align-items: center;
  background-color: transparent;
  padding: 0;
  padding-left: 0.5rem;
  text-transform: uppercase;
  cursor: pointer;
  &:hover {
    transition: background-color 0.3s;
    background-color: ${theme.palette.neutral.dark};
  }
`
